import { render } from "./AttributesSection.vue?vue&type=template&id=7b6764aa&scoped=true"
import script from "./AttributesSection.vue?vue&type=script&lang=js"
export * from "./AttributesSection.vue?vue&type=script&lang=js"

import "./AttributesSection.vue?vue&type=style&index=0&id=7b6764aa&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b6764aa"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QChip,QField});
